import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Tooltip } from 'src/componentes'
import { Botao } from 'src/componentes/botao'
import { Breadcrumb } from 'src/componentes/breadcrumb'
import { Cabecalho } from 'src/componentes/cabecalho'
import { ContainerAcoes } from 'src/componentes/container-acoes'
import { Filtro } from 'src/componentes/filtro'
import { IconeEditar } from 'src/componentes/icones'
import {
  Container,
  Dados,
  Form,
  ContainerDados25,
  ContainerDados75
} from 'src/componentes/styles/filtro'
import {
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta
} from 'src/componentes/tabela'
import { InputUnform } from 'src/componentes/unform/input'
import { SelectAsyncUnform, SelectUnform } from 'src/componentes/unform/select'
import { RotasDisciplina } from 'src/rotas'
import { Api } from 'src/servicos'
import { RequisitarListaCursosPorTexto } from 'src/servicos/api/curso'
import {
  TipoOrdenacao,
  DisciplinaSituacao,
  DadosPesquisaDisciplina
} from 'src/tipos'

export const PaginaDisciplinas: React.FC = () => {
  const tabelaRef = useRef<TabelaRef>()
  const history = useHistory()
  const [
    dadosPesquisa,
    definirDadosPesquisa
  ] = useState<DadosPesquisaDisciplina>(null)
  const [paginas, definirPaginas] = useState(null)

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.IrParaPagina()
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  const acaoPesquisa = (dados: DadosPesquisaDisciplina) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }
    definirDadosPesquisa(dados)
  }
  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }
    const dados = await Api.RequisitarListaDisciplinas(
      dadosPesquisa?.codigo,
      dadosPesquisa?.nome,
      dadosPesquisa?.cursoDis,
      dadosPesquisa?.situacao,
      numeroPaginas,
      quantidadePorPagina,
      chaveOrdenacao,
      ordem
    )

    if (!dados) return null
    definirPaginas(null)

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina:
          dados.opcoesPaginacao.totalPaginas < dados.opcoesPaginacao.pagina
            ? 1
            : dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  return (
    <>
      <Cabecalho>
        <Breadcrumb
          titulo="Pesquisa de Disciplinas"
          atalhos={[
            {
              texto: 'Acadêmico'
            },
            {
              texto: 'Disciplinas'
            }
          ]}
        />
        <Botao
          type="button"
          texto="Incluir"
          tema="Secundario"
          onClick={() => history.push(RotasDisciplina.Cadastro)}
        />
      </Cabecalho>
      <Filtro>
        <Form
          acaoSucesso={acaoPesquisa}
          dadosIniciais={{
            situacao: DisciplinaSituacao[DisciplinaSituacao.Todas]
          }}
        >
          <Container>
            <ContainerDados25>
              <InputUnform
                type="text"
                name="codigo"
                label="Código"
                maxLength={10}
              />
            </ContainerDados25>
            <ContainerDados75>
              <InputUnform
                type="text"
                name="nome"
                label="Nome"
                maxLength={200}
              />
            </ContainerDados75>
          </Container>
          <Container>
            <ContainerDados25>
              <SelectUnform
                id="slct_situacoes"
                name="situacao"
                label="Situação"
                iconeFechar={false}
                opcoes={[
                  {
                    id: DisciplinaSituacao[DisciplinaSituacao.Todas],
                    texto: 'Todas'
                  },
                  {
                    id: DisciplinaSituacao[DisciplinaSituacao.Ativo],
                    texto: 'Ativo'
                  },
                  {
                    id: DisciplinaSituacao[DisciplinaSituacao.Inativo],
                    texto: 'Inativo'
                  }
                ]}
              />
            </ContainerDados25>
            <ContainerDados75>
              <SelectAsyncUnform
                id="slct_cursos"
                name="cursoDis"
                label="Curso"
                buscarPorTexto={RequisitarListaCursosPorTexto}
                buscarPorId={RequisitarListaCursosPorTexto}
              />
            </ContainerDados75>
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <Tabela
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'codigo',
              Texto: 'Código',
              ComOrdenacao: true
            },
            {
              Chave: 'nome',
              Texto: 'Nome',
              ComOrdenacao: true
            },
            {
              Chave: 'cargaHoraria',
              Texto: 'Carga Horária',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <>{linha.cargaHoraria.toString().replace('.', ',')}</>
              )
            },
            {
              Chave: 'situacao',
              Texto: 'Situação',
              ComOrdenacao: true
            },
            {
              Chave: 'tipo',
              Texto: 'Tipo',
              ComOrdenacao: true
            },
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  <button
                    type="button"
                    data-tip="Editar"
                    data-for={`${linha.id}-tooltip-editar`}
                    onClick={() =>
                      history.push(`${RotasDisciplina.Edicao}/${linha.id}`)
                    }
                    onContextMenu={() => {
                      const rota = window.open(
                        `${RotasDisciplina.Edicao}/${linha.id}`
                      )
                      rota.focus()
                    }}
                  >
                    {IconeEditar}
                  </button>
                  <Tooltip
                    id={`${linha.id}-tooltip-editar`}
                    offset={{ top: 10 }}
                  />
                </ContainerAcoes>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
    </>
  )
}

export { default as PaginaCadastroDisciplinas } from './cadastro'
